/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const legsTwist3Components = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'body', true).withEntity('LegsTwist3').attach(memoEval((self)=>[
            self.$objectName
        ], ($objectName)=>({
            fileUrl: '/models/algu3d.glb',
            objectName: $objectName,
            dimensionUnit: 'm'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'body', true).withEntity('LegsTwist3').attach(memoEval((self)=>[
            self.$diameter,
            self.$height
        ], ($diameter, $height)=>({
            morphTargetInfluences: {
                Diameter: {
                    value: $diameter,
                    scaleOne: 1800,
                    scaleZero: 1000
                },
                Height: {
                    value: $height,
                    scaleOne: 780,
                    scaleZero: 740
                }
            }
        })))
];

//# sourceMappingURL=legs-twist-3.js.map